import(/* webpackMode: "eager", webpackExports: ["NotFoundContent"] */ "/builds/empiriecom/core/frontend/turborepo/apps/order/src/app/[lang]/NotFoundContent.client.tsx");
